import React, { FC, memo } from 'react'
import { ZoneMenu } from 'modulesCommon/Header/components'

const ZoneMenuContainer: FC = memo(() => {

  return (
    <ZoneMenu />
  )
})

export default ZoneMenuContainer
